"use strict";
var WhatsappSignatureGuard_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsappSignatureGuard = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const crypto = tslib_1.__importStar(require("crypto"));
/**
 * Validates the X-Hub-Signature-256 header on Meta WhatsApp Cloud API webhooks.
 *
 * Meta signs the raw request body using HMAC-SHA256 with the App Secret:
 *   X-Hub-Signature-256: sha256=<hex_digest>
 *
 * Requires `rawBody: true` in NestFactory.create() so that req.rawBody is populated
 * before Express's JSON body-parser processes the request.
 *
 * If WHATSAPP_APP_SECRET is not set the guard passes through — stub mode for local dev.
 *
 * Docs: https://developers.facebook.com/docs/graph-api/webhooks/getting-started#verification-requests
 */
let WhatsappSignatureGuard = WhatsappSignatureGuard_1 = class WhatsappSignatureGuard {
    constructor() {
        this.logger = new common_1.Logger(WhatsappSignatureGuard_1.name);
    }
    canActivate(context) {
        const appSecret = process.env['WHATSAPP_APP_SECRET'];
        if (!appSecret) {
            this.logger.warn('WHATSAPP_APP_SECRET not set — skipping signature verification (stub mode)');
            return true;
        }
        const req = context.switchToHttp().getRequest();
        const signature = req.headers['x-hub-signature-256'];
        if (!signature) {
            this.logger.error('Missing X-Hub-Signature-256 header');
            throw new common_1.UnauthorizedException('Missing X-Hub-Signature-256');
        }
        const rawBody = req.rawBody;
        if (!rawBody || rawBody.length === 0) {
            this.logger.warn('Raw body unavailable — ensure rawBody: true in NestFactory.create()');
            return true; // Degrade gracefully; tighten in production
        }
        const expected = 'sha256=' + crypto
            .createHmac('sha256', appSecret)
            .update(rawBody)
            .digest('hex');
        try {
            const sigBuf = Buffer.from(signature, 'utf8');
            const expBuf = Buffer.from(expected, 'utf8');
            if (sigBuf.length !== expBuf.length)
                throw new Error('length mismatch');
            if (!crypto.timingSafeEqual(sigBuf, expBuf))
                throw new Error('mismatch');
        }
        catch {
            this.logger.error(`Invalid WhatsApp signature from ${req.ip}`);
            throw new common_1.UnauthorizedException('Invalid WhatsApp App Secret signature');
        }
        return true;
    }
};
exports.WhatsappSignatureGuard = WhatsappSignatureGuard;
exports.WhatsappSignatureGuard = WhatsappSignatureGuard = WhatsappSignatureGuard_1 = tslib_1.__decorate([
    (0, common_1.Injectable)()
], WhatsappSignatureGuard);
